import { SpeakingSlotStatus, SpeakingSlotType } from 'api/planning';
import { SpeakingSlotAction } from './SpeakingSlotAction';

export const getSpeakingSlotStatusFromSpeakingSlotAction = (
  action: SpeakingSlotAction,
  speakingSlotType: SpeakingSlotType
): SpeakingSlotStatus | undefined => {
  if (action === SpeakingSlotAction.AddSlot) {
    return speakingSlotType === SpeakingSlotType.RSS
      ? SpeakingSlotStatus.AwaitingApproval
      : SpeakingSlotStatus.Available;
  }
  if (action === SpeakingSlotAction.AddBreak) {
    return SpeakingSlotStatus.Break;
  }
  return undefined;
};
